// extracted by mini-css-extract-plugin
export default {"mainWrapper":"_Main_mainWrapper__1l26r"};